import { jsx as _jsx } from "react/jsx-runtime";
import { LabeledValue } from "./LabeledValue.js";
export const LabeledSelectValue = ({ label, value, options, notSetText, ...props }) => {
    const selectedOption = options.find(o => o.value === value);
    return (_jsx(LabeledValue, { label: label, notSet: !selectedOption, ...props, children: selectedOption ? selectedOption.label : notSetText }));
};
//# sourceMappingURL=LabeledSelectValue.js.map